<ul [ngClass]="['cdx-block', 'cdx-list', 'cdx-list--' + content.style]">
  <li class="cdx-list__item" *ngFor="let i of content.items" [innerHTML]="i"></li>
</ul>